import {createMuiTheme} from '@material-ui/core';
import {responsiveFontSizes} from '@material-ui/core/styles';
// import {deepPurple, amber} from '@material-ui/core/colors';

// #484642 - dark header for AP
// #F8AF3A - ap theme (orange)
// https://source.unsplash.com/random

const theme = createMuiTheme({
    typography: {
        fontFamily: [
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),
        body1: {
            // fontWeight: 500,
            fontSize: '0.875rem'
        },
        button: {
            textTransform: "none"
        }
    },
    palette: {
        primary: {
            // main: '#F8AF3A',
            main: '#EF6527',
            contrastText: '#fff',
        },
        secondary: {
            main: '#2196f3',
            contrastText: '#fff',
        }
        // secondary: {
        //     main: amber[500],
        //     contrastText: deepPurple[900]
        // }
    },
    overrides: {
        MuiTableCell: {
            root: {
                paddingLeft: '25px',
                paddingTop: '5px',
                paddingBottom: '5px'
                // padding: '5px 5px 5px 25px'
            }
        },
        MuiTableRow: {
            hover: {
                "&$hover:hover": {
                    // remove the pink hover color when table row is selected
                    backgroundColor: '#F5F5F5',
                }
            }
        }
    }
});

export default responsiveFontSizes(theme);